module.exports = __webpack_public_path__ + "3-61.jpg?54d987bb6bd0d6db0f994c9ec6e9be51";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-61.jpg
// module id = 143
// module chunks = 0